<template>
  <v-menu offset-y nudge-left="120px" :close-on-content-click="closeOnContentClick">
    <template v-slot:activator="{ on }">
      <v-btn
        icon medium
        v-on="on"
        :loading="isFetching"
        class="btn-print mb-4"
        @click="checkSchedule"
      >
        <v-col cols="12" class="btn-text">
          <v-icon color="#757575">local_printshop</v-icon>
          <span>{{$t('print_files.export')}}</span>
        </v-col>
      </v-btn>
     </template>
    <v-list v-if="!isFetching">
      <v-list-group v-for="(level, index) in levels" :key="level.index" @click="takeIndex(index)">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>{{level.title}}</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list class='py-0 pl-1'>
          <v-list-item @click="printPdf">
            <v-list-item-title>PDF</v-list-item-title>
          </v-list-item>
          <v-list-item @click="printCsv">
            <v-list-item-title>CSV</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-list-group>
    </v-list>
  </v-menu>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { dropHelpers, generalHelpers } from '@/_helpers'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import Roboto from '@/assets/fonts/Roboto-Regular-normal.js'
import RobotoBold from '@/assets/fonts/Roboto-Bold-bold.js'
import { shipmentService, orderService } from '@/_services'
import * as Sentry from '@sentry/browser'

export default {
  name: 'ExportScheduleList',
  components: {},
  props: {},
  data () {
    return {
      levels: [
        { title: this.$i18n.t('print_files.schedule_list') },
        { title: this.$i18n.t('print_files.expedition_list') },
        { title: this.$i18n.t('print_files.order_list') },
        { title: this.$i18n.t('print_files.quote_list') }
      ],
      closeOnContentClick: false,
      buttonClicked: null,
      loading: false,
      headOne: [],
      headTwo: [],
      body: [],
      rows: [],
      dropDetails: [],
      numberPackages: [],
      orders: null,
      disabled: true,
      sortedArray: [],
      drops: null,
      expDate: null,
      expDateCsv: null,
      expOrigin: null,
      expOriginCsv: null,
      expDestinationCsv: null,
      expDestination: null,
      expVolume: null,
      expWeight: null,
      expNumber: null,
      schDate: null,
      schCompanyRef: null,
      schCompanyName: null,
      schLocation: null,
      schLocationCsv: null,
      quoteDate: null,
      quoteCompanyName: null,
      quoteStatus: null,
      quotePrice: null
    }
  },
  computed: {
    ...mapGetters({getSelectedResource: 'getSelectedResource',
                   getSelectedResourceID: 'getSelectedResourceID',
                   getShipmentResourceSchedule: 'getShipmentResourceSchedule',
                   getShipmentResourceDrops: 'getShipmentResourceDrops',
                   getShipmentResourceDropsDetails: 'getShipmentResourceDropsDetails',
                   getShipmentSchedule: 'getShipmentSchedule',
                   getQuoteListExport: 'exportData/getQuoteListExport',
                   getIsFetching: 'exportData/getIsFetching'
                  }),
    ...mapGetters('cognito', ['userAttributes']),
    isFetching () {
      return this.getIsFetching
    }
  },
  methods: {
    ...mapActions({ setShipmentSchedule: 'setShipmentSchedule',
                    showSnackbar: 'showSnackbar',
                    fetchQuoteList: 'exportData/fetchQuoteList'
                  }),
    takeIndex (index) {
      this.buttonClicked = index
    },
    checkSchedule () {
      this.setShipmentSchedule({ shipmentID: this.getSelectedResource.id, drops: this.getShipmentResourceDrops })
      this.fetchQuoteList({ shipmentID: this.getSelectedResource.id })
    },
    printPdf () {
      if (this.buttonClicked === 0) {
        this.exportScheduleListPdf()
      } else if (this.buttonClicked === 1) {
        this.exportExpeditionListPdf()
      } else if (this.buttonClicked === 2) {
        this.exportOrderListPdf()
      } else if (this.buttonClicked === 3) {
        this.exportQuoteListPdf()
      }
    },
    printCsv () {
      if (this.buttonClicked === 0) {
        this.exportScheduleListCsv()
      } else if (this.buttonClicked === 1) {
        this.exportExpeditionListCsv()
      } else if (this.buttonClicked === 2) {
        this.exportOrderListCsv()
      } else if (this.buttonClicked === 3) {
        this.exportQuoteListCsv()
      }
    },
    addDocSettings (doc) {
      doc.addFileToVFS('Roboto-Regular.ttf', Roboto)
      doc.addFileToVFS('Roboto-Bold.ttf', RobotoBold)
      doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal')
      doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold')
      doc.setFont('Roboto')
    },
    setHeaderPdf () {
      console.log(this.getSelectedResource)
      let date = this.$options.filters.dateToReadable(this.getSelectedResource, this.$i18n.locale)
      let carrier, driver, vehicleName, registrationPlate, totalWeight, totalVolume, packageNumber, deliveryNumber
      let labelArray = []
      if (this.getSelectedResource.carrier === null) {
        carrier = 'n/a'
      } else {
        carrier = this.getSelectedResource.carrier
      }
      driver = 'n/a'
      vehicleName = 'n/a'
      registrationPlate = 'n/a'
      totalWeight = this.$options.filters.roundValueWeight(this.getSelectedResource.weight, 0)
      totalVolume = this.$options.filters.roundValue(this.getSelectedResource.volume, 1)
      if (this.getSelectedResource.units === null) {
        packageNumber = 'N/A'
      } else {
        this.getSelectedResource.units.forEach((unit) => {
          packageNumber = 0
          packageNumber += unit.count
        })
      }
      // packageNumber = Object.values(this.getSelectedResource.unitTypes)

      deliveryNumber = this.getShipmentResourceSchedule.length

      if (this.getSelectedResource.labels !== null) {
        this.getSelectedResource.labels.forEach((label) => {
        labelArray.push(label)
        })
      } else {
        labelArray.push('N/A')
      }
      // first table with general info
      this.headOne.push(
        [
          { content: `${this.$i18n.t('print_files.delivery_date')}: ${date}` },
          { content: `${this.$i18n.t('print_files.weight')}: ${totalWeight} kg` },
          { content: `${this.$i18n.t('print_files.driver')}: ${driver}` }
        ],
        [
          { content: `${this.$i18n.t('print_files.deliveries')}: ${deliveryNumber}` },
          { content: `${this.$i18n.t('print_files.volume')}: ${totalVolume} m³` },
          { content: `${this.$i18n.t('print_files.vehicle_name')}: ${vehicleName}` }
        ],
        [
          { content: `${this.$i18n.t('print_files.labels')}: ${labelArray}` },
          { content: `${this.$i18n.t('print_files.packages')}: ${packageNumber}` },
          { content: `${this.$i18n.t('print_files.registration_plate')}: ${registrationPlate}` }
        ],
        [
          { content: '' },
          { content: '' },
          { content: `${this.$i18n.t('print_files.carrier')}: ${carrier}` }
        ]
      ) 
    },
    setFooterPdf (doc, pageX, pageY, printX, printY, generateX, generateY) {
      let pageCount = doc.internal.getNumberOfPages()
      let dateObj = new Date()
      let day = dateObj.getDate()
      // months in js are indexed from 0
      let month = dateObj.getMonth() + 1
      let year = dateObj.getFullYear()
      let hour = dateObj.getHours()
      // adds 0 in front of minutes when needed
      let minute = String(dateObj.getMinutes()).padStart(2, '0')
      let newDate = day + '/' + month + '/' + year
      let newTime = hour + ':' + minute
      for (let i = 0; i < pageCount; i++) {
        doc.setFontSize(14)
        doc.setPage(i)
        doc.text(pageX, pageY, this.$i18n.t('print_files.pages') + ': ' + doc.internal.getCurrentPageInfo().pageNumber + '/' + pageCount)
        doc.setFontSize(9)
        doc.text(printX, printY, `${this.$i18n.t('print_files.printed')} ${newDate} ${this.$i18n.t('print_files.at')} ${newTime} ${this.$i18n.t('print_files.by')} ${this.userAttributes.email}`)
        doc.text(generateX, generateY, this.$i18n.t('print_files.generated'))
      }
    },
    generateCsv (csvContent, name) {
      let encodedUri = encodeURI(csvContent)
      let link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      link.setAttribute('download', `${this.$i18n.t(name)}.csv`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    scheduleFile (i) {
      this.schDate = null
      this.schCompanyRef = null
      this.schCompanyName = null
      this.schLocation = null
      this.schLocationCsv = null
      this.schDate = this.$options.filters.dateToReadableTz(this.getShipmentSchedule.stops[i].arrival, this.$i18n.locale)

      let city, postalCode, street, streetNo

      if (this.getShipmentSchedule.stops[i].location.organization.ref === '' || this.getShipmentSchedule.stops[i].location.organization.ref === null) {
        this.schCompanyRef = 'n/a'
      } else {
        this.schCompanyRef = this.getShipmentSchedule.stops[i].location.organization.ref
      }

      if (this.getShipmentSchedule.stops[i].location.organization.name !== null || this.getShipmentSchedule.stops[i].location.organization.name !== '') {
        this.schCompanyName = this.getShipmentSchedule.stops[i].location.organization.name
      } else {
        this.schCompanyName = 'N/A'
      }
      
      if (this.getShipmentSchedule.stops[i].location.address &&
          this.getShipmentSchedule.stops[i].location.address.city !== null &&
          this.getShipmentSchedule.stops[i].location.address.city !== '') {
        city = this.getShipmentSchedule.stops[i].location.address.city
      } else {
        city = 'N/A'
      }

      if (this.getShipmentSchedule.stops[i].location.address &&
          this.getShipmentSchedule.stops[i].location.address.postalCode !== null &&
          this.getShipmentSchedule.stops[i].location.address.postalCode !== '') {
        postalCode = this.getShipmentSchedule.stops[i].location.address.postalCode
      } else {
        postalCode = 'N/A'
      }

      if (this.getShipmentSchedule.stops[i].location.address &&
          this.getShipmentSchedule.stops[i].location.address.street !== null &&
          this.getShipmentSchedule.stops[i].location.address.street !== '') {
        street = this.getShipmentSchedule.stops[i].location.address.street
      } else {
        street = 'N/A'
      }

      if (this.getShipmentSchedule.stops[i].location.address &&
          this.getShipmentSchedule.stops[i].location.address.streetNo !== null &&
          this.getShipmentSchedule.stops[i].location.address.streetNo !== '') {
        streetNo = this.getShipmentSchedule.stops[i].location.address.streetNo
      } else {
        streetNo = 'N/A'
      }

      this.schLocation = `${city}, ${postalCode}\n${street} ${streetNo}`
      this.schLocationCsv = `${city} - ${postalCode} - ${street} ${streetNo}`
    },
    expeditionFile (i) {
      this.expDate = null
      this.expDateCsv - null
      this.expOrigin = null
      this.expOriginCsv = null
      this.expDestination = null
      this.expDestinationCsv = null
      this.expVolume = null
      this.expWeight = null
      this.expNumber = null
      let street, streetNo, city, postalCode

      this.expDate = `${this.$i18n.t('print_files.departure')}: ${this.$options.filters.dateToReadableFull(this.dropDetails[i].departure, this.$i18n.locale)}\n${this.$i18n.t('print_files.arrival')}: ${this.$options.filters.dateToReadableFull(this.dropDetails[i].arrival, this.$i18n.locale)}`
      this.expDateCsv = `${this.$i18n.t('print_files.departure')}: ${this.$options.filters.dateToReadableFull(this.dropDetails[i].departure, this.$i18n.locale)} - ${this.$i18n.t('print_files.arrival')}: ${this.$options.filters.dateToReadableFull(this.dropDetails[i].arrival, this.$i18n.locale)}`
      
      if (this.dropDetails[i].origin.address && this.dropDetails[i].origin.address.street !== null && this.dropDetails[i].origin.address.street !== '') {
        street = this.dropDetails[i].origin.address.street
      } else {
        street = 'N/A'
      }

      if (this.dropDetails[i].origin.address && this.dropDetails[i].origin.address.streetNo !== null && this.dropDetails[i].origin.address.streetNo !== '') {
        streetNo = this.dropDetails[i].origin.address.streetNo
      } else {
        streetNo = 'N/A'
      }

      if (this.dropDetails[i].origin.address && this.dropDetails[i].origin.address.city !== null && this.dropDetails[i].origin.address.city !== '') {
        city = this.dropDetails[i].origin.address.city
      } else {
        city = 'N/A'
      }

      if (this.dropDetails[i].origin.address && this.dropDetails[i].origin.address.postalCode !== null && this.dropDetails[i].origin.address.postalCode !== '') {
        postalCode = this.dropDetails[i].origin.address.postalCode
      } else {
        postalCode = 'N/A'
      }
      
      if (this.dropDetails[i].origin.organization.ref === '') {
        this.expOrigin = `${this.dropDetails[i].origin.organization.name}\nref: n/a\n${street} ${streetNo}\n${city} ${postalCode}`
        this.expOriginCsv = `${this.dropDetails[i].origin.organization.name} - ref: n/a - ${street} ${streetNo} - ${city} ${postalCode}`
      } else {
        this.expOrigin = `${this.dropDetails[i].origin.organization.name}\nref: ${this.dropDetails[i].origin.organization.ref}\n${street} ${streetNo}\n${city} ${postalCode}`
        this.expOriginCsv = `${this.dropDetails[i].origin.organization.name} - ref: ${this.dropDetails[i].origin.organization.ref} - ${street} ${streetNo} - ${city} ${postalCode}`   
      }
      if (this.dropDetails[i].destination.organization.ref === '') {
        this.expDestination = `${this.dropDetails[i].destination.organization.name}\nref: n/a\n${street} ${streetNo}\n${city} ${postalCode}`
        this.expDestinationCsv = `${this.dropDetails[i].destination.organization.name} - ref: n/a - ${street} ${streetNo} - ${city} ${postalCode}`
      } else {
        this.expDestination = `${this.dropDetails[i].destination.organization.name}\nref: ${this.dropDetails[i].destination.organization.ref}\n${street} ${streetNo}\n${city} ${postalCode}`
        this.expDestinationCsv = `${this.dropDetails[i].destination.organization.name} - ref: ${this.dropDetails[i].destination.organization.ref} - ${street} ${streetNo} - ${city} ${postalCode}`
      }
      this.expVolume = this.$options.filters.roundValue(this.dropDetails[i].volume, 1)
      this.expWeight = this.$options.filters.roundValueWeight(this.dropDetails[i].weight, 0)
      for (let k = 0; k < this.dropDetails[i].unitsCount.length; k++) {
        this.expNumber = this.dropDetails[i].unitsCount[k].count
      }
    },
    orderFile (drop) {
      let orderRef, buyerRef, companyName, address, priority, roundedWeight, roundedVolume, city, street, streetNo, country
      let weight = 0
      let volume = 0

      weight = 0
      volume = 0
      for (let i = 0; i < drop.transports.length; i++) {
        weight = 0
        volume = 0
        orderRef = drop.transports[i].ref
        buyerRef = drop.destination.organization.ref
        companyName = drop.destination.organization.name

        if (drop.destination.address &&
            drop.destination.address.city !== null &&
           drop.destination.address.city !== '') {
            city = drop.destination.address.city
        }else {
            city = 'N/A'
        }

        if (drop.destination.address &&
            drop.destination.address.country !== null &&
            drop.destination.address.country !== '') {
              country = drop.destination.address.country
        }else {
              country = 'N/A'
        }

        if (drop.destination.address &&
            drop.destination.address.street !== null &&
            drop.destination.address.street !== '') {
              street = drop.destination.address.street
        }else {
              street = 'N/A'
        }

        if (drop.destination.address.address &&
            drop.destination.address.streetNo !== null &&
            drop.destination.address.streetNo !== '') {
              streetNo = drop.destination.address.streetNo
        }else {
              streetNo = 'N/A'
        }

      
        address = `${street} ${streetNo}, ${city} ${country}`

        if (drop.transports[i].priority && drop.transports[i].priority !== null && drop.transports[i].priority !== '') {
          priority = drop.transports[i].priority
        } else {
          priority = 'N/A'
        }
        
        drop.transports[i].units.forEach((unit) => {
          weight += unit.weight
          roundedWeight = this.$options.filters.roundValueWeight(weight, 0)
          volume += ((unit.dimensions.length * unit.dimensions.width * unit.dimensions.height) * 0.000001)
          roundedVolume = this.$options.filters.roundValue(volume, 1)
        })
        this.body.push([orderRef, buyerRef, companyName, address, priority, roundedWeight, roundedVolume])
        this.rows.push([orderRef, buyerRef, companyName, address, priority, roundedWeight, roundedVolume])
      }
    },
    quoteFile (i) {
      this.quoteDate = null
      this.quoteCompanyName = null
      this.quoteStatus = null
      this.quotePrice = null

      if (this.getQuoteListExport[i].status === 'Requested') {
        this.quoteDate = this.$options.filters.dateToReadableFullMoment(this.getQuoteListExport[i].createdAt, this.$i18n.locale)
      } else {
        this.quoteDate = this.$options.filters.dateToReadableFullMoment(this.getQuoteListExport[i].quoteddAt, this.$i18n.locale)
      }
      
      if (this.getQuoteListExport[i].organization && this.getQuoteListExport[i].organization.name !== null && this.getQuoteListExport[i].organization.name !== '') {
        this.quoteCompanyName = this.getQuoteListExport[i].organization.name
      } else {
        this.quoteCompanyName = 'N/A'
      }
      
      this.quoteStatus = this.getQuoteListExport[i].status

      if (this.getQuoteListExport[i].price !== null) {
        this.quotePrice = `${this.getQuoteListExport[i].price} ${this.getQuoteListExport[i].currency}`
      } else {
        this.quotePrice = 'N/A'
      } 
    },
    exportScheduleListPdf () {
      this.headOne = []
      this.headTwo = []
      this.body = []
      // console.log(this.getSelectedResource)
      // console.log(this.getShipmentResourceSchedule)
      // console.log(this.getShipmentSchedule)
      this.loading = true
      let Pdf = jsPDF
      let doc = new Pdf()
      // font to Roboto so we won't have problems with encoding
      this.addDocSettings(doc)

      doc.setFontSize(14)
      doc.setFontStyle('bold')
      doc.text(this.$i18n.t('print_files.schedule_list').toUpperCase(), 85, 10)
      doc.setFontStyle('normal')

      // header table
      this.setHeaderPdf()

      // second table with schedule
      this.headTwo.push(
        [
          { content: this.$i18n.t('print_files.date') },
          { content: this.$i18n.t('print_files.company_ref') },
          { content: this.$i18n.t('print_files.company') },
          { content: this.$i18n.t('print_files.location') }
        ]
      )
      try {
        for (let i = 0; i < this.getShipmentSchedule.stops.length; i++) {
          this.scheduleFile(i)
          this.body.push([this.schDate, this.schCompanyRef, this.schCompanyName, this.schLocation])
        }
      } catch (err) {
        Sentry.captureException(err)
        this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
        this.loading = false
      }

      doc.autoTable({
        head: this.headOne,
        styles: { fontSize: 10, textColor: [33, 33, 33], font: 'Roboto' },
        headStyles: { fillColor: [246, 246, 246] },
        startY: 20
      })

      doc.autoTable({
        head: this.headTwo,
        body: this.body,
        styles: { fontSize: 10, textColor: [33, 33, 33], font: 'Roboto' },
        theme: 'grid',
        rowPageBreak: 'avoid',
        headStyles: { fillColor: [255, 255, 255], lineWidth: 0.1 },
        columnStyles: { 0: { cellWidth: 40 }, 2: { cellWidth: 50 }, 3: { cellWidth: 50 } },
        startY: 60
      })

      this.setFooterPdf(doc, 175, 10, 10, 290, 160, 290)

      try {
        doc.save(`${this.$i18n.t('print_files.schedule_list_file_name')}.pdf`)
      } catch (err) {
        Sentry.captureException(err)
        this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
        this.loading = false
      }
      this.loading = false
    },
    exportScheduleListCsv () {
      this.loading = true
      this.rows = []

      let csvContent = 'data:text/csv;charset=utf-8,'
      this.rows.push([this.$i18n.t('print_files.date'), this.$i18n.t('print_files.company_ref'), this.$i18n.t('print_files.company'), this.$i18n.t('print_files.location')])
      
      try {
        for (let i = 0; i < this.getShipmentSchedule.stops.length; i++) {
          this.scheduleFile(i)
          this.rows.push([this.schDate, this.schCompanyRef, this.schCompanyName, this.schLocationCsv])
        }
      } catch (err) {
        Sentry.captureException(err)
        this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
        this.loading = false
      }
      this.rows.forEach(function (rowArray) {
        let row = rowArray.join(';').replace(',', '-')
        csvContent += row + '\r\n'
      })

      try {
        this.generateCsv(csvContent, 'print_files.schedule_list_file_name')
      } catch (err) {
        Sentry.captureException(err)
        this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
        this.loading = false
      }

      this.loading = false
    },
    async getDropsData () {
      let dropsID = []
      // get the drop ids and push then into the array
      for (let i = 0; i < this.getShipmentResourceDrops.length; i++) {
        dropsID.push(this.getShipmentResourceDrops[i].id)
      }
      // use the drop ids to get the drop details to get the number of packages
      this.dropDetails = await shipmentService.getBatchShipmentDrops({ dropIDs: dropsID })
      this.dropDetails.forEach(detail => {
        this.numberPackages.push(...detail.unitsCount)
      })
    },
    async getOrderData () {
      this.orders = await shipmentService.getShipmentWithDropsTransport({shipmentID: this.getSelectedResource.id})
      this.drops = this.orders.drops
      // console.log(this.drops)
    },
    async exportExpeditionListPdf () {
      await this.getDropsData()
      this.headOne = []
      this.headTwo = []
      this.body = []
      // console.log(this.getShipmentResourceDrops)
      this.loading = true
      let Pdf = jsPDF
      let doc = new Pdf('landscape')
      // font to Roboto so we won't have problems with encoding
      this.addDocSettings(doc)

      doc.setFontSize(14)

      doc.setFontStyle('bold')
      doc.text(this.$i18n.t('print_files.expedition_list').toUpperCase(), 130, 10)
      doc.setFontStyle('normal')

      // header table
      this.setHeaderPdf()

      this.headTwo.push(
        [
          { content: this.$i18n.t('print_files.date') },
          { content: this.$i18n.t('print_files.origin') },
          { content: this.$i18n.t('print_files.destination') },
          { content: this.$i18n.t('print_files.weight') + ' [KG]' },
          { content: this.$i18n.t('print_files.volume') + ' [CBM]' },
          { content: this.$i18n.t('print_files.packages') }
        ]
      )
      try {
        for (let i = 0; i < this.dropDetails.length; i++) {
          this.expeditionFile(i)
          this.body.push([this.expDate, this.expOrigin, this.expDestination, this.expWeight, this.expVolume, this.expNumber])
        }
      } catch (err) {
        Sentry.captureException(err)
        this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
        this.loading = false
      }
      doc.autoTable({
        head: this.headOne,
        styles: { fontSize: 10, textColor: [33, 33, 33], font: 'Roboto' },
        headStyles: { fillColor: [246, 246, 246] },
        startY: 20
      })
      doc.autoTable({
        head: this.headTwo,
        body: this.body,
        styles: { fontSize: 10, textColor: [33, 33, 33], font: 'Roboto' },
        theme: 'grid',
        rowPageBreak: 'avoid',
        headStyles: { fillColor: [255, 255, 255], lineWidth: 0.1 },
        columnStyles: { 0: { cellWidth: 50 }, 1: { cellWidth: 60 }, 2: { cellWidth: 60 }, 3: { halign: 'right' }, 4: { halign: 'right' }, 5: { halign: 'right' } },
        startY: 60
      })
      this.setFooterPdf(doc, 259, 10, 14, 203, 244, 203)
      try {
        doc.save(`${this.$i18n.t('print_files.expedition_list_file_name')}.pdf`)
      } catch (err) {
        Sentry.captureException(err)
        this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
        this.loading = false
      }
      this.loading = false
    },
    async exportExpeditionListCsv () {
      await this.getDropsData()
      this.loading = true
      this.rows = []

      let csvContent = 'data:text/csv;charset=utf-8,'
      this.rows.push([this.$i18n.t('print_files.date'), this.$i18n.t('print_files.origin'), this.$i18n.t('print_files.destination'), this.$i18n.t('print_files.weight') + ' [KG]', this.$i18n.t('print_files.volume') + ' [CBM]', this.$i18n.t('print_files.packages')])
      
      try {
        for (let i = 0; i < this.dropDetails.length; i++) {
          this.expeditionFile(i)
          this.rows.push([this.expDateCsv, this.expOriginCsv, this.expDestinationCsv, this.expWeight, this.expVolume, this.expNumber])
        }
      } catch (err) {
        Sentry.captureException(err)
        this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
        this.loading = false
      }
      
      this.rows.forEach(function (rowArray) {
        let row = rowArray.join(';').replace(',', '-')
        csvContent += row + '\r\n'
      })
      try {
        this.generateCsv(csvContent, 'print_files.expedition_list_file_name')
      } catch (err) {
        Sentry.captureException(err)
        this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
        this.loading = false
      }
      this.loading = false
    },
    async exportOrderListPdf () {
      await this.getOrderData()
      this.headOne = []
      this.headTwo = []
      this.body = []
      this.loading = true
      let Pdf = jsPDF
      let doc = new Pdf('landscape')
      // font to Roboto so we won't have problems with encoding
      this.addDocSettings(doc)

      doc.setFontSize(14)

      doc.setFontStyle('bold')
      doc.text(this.$i18n.t('print_files.order_list').toUpperCase(), 130, 10)
      doc.setFontStyle('normal')
      
      // header table
      this.setHeaderPdf()

      // second table with orders data
      this.headTwo.push(
        [
          { content: this.$i18n.t('print_files.order_ref') },
          { content: this.$i18n.t('print_files.buyer_ref') },
          { content: this.$i18n.t('print_files.company_name') },
          { content: this.$i18n.t('print_files.address') },
          { content: this.$i18n.t('orders.priority') },
          { content: this.$i18n.t('print_files.weight') + ' [KG]' },
          { content: this.$i18n.t('print_files.volume') + ' [CBM]' }
        ]
      )
      try {
        this.drops.forEach((drop) => {
         this.orderFile (drop)
        })
      } catch (err) {
        Sentry.captureException(err)
        this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
        this.loading = false
      }

      // sort by order reference number
      this.body.sort((a, b) => (a[0] > b[0]) ? 1 : -1)
      doc.autoTable({
        head: this.headOne,
        styles: { fontSize: 10, textColor: [33, 33, 33], font: 'Roboto' },
        headStyles: { fillColor: [246, 246, 246] },
        startY: 22
      })
      doc.autoTable({
        head: this.headTwo,
        body: this.body,
        styles: { fontSize: 10, textColor: [33, 33, 33], font: 'Roboto' },
        theme: 'grid',
        rowPageBreak: 'avoid',
        headStyles: { fillColor: [255, 255, 255], lineWidth: 0.1 },
        columnStyles: { 0: { cellWidth: 30 }, 1: { cellWidth: 40 }, 3: { cellWidth: 40 }, 4: { cellWidth: 40 }, 5: { halign: 'right', cellWidth: 22 }, 6: { halign: 'right', cellWidth: 26 }, 7: { halign: 'right', cellWidth: 20 } },
        startY: 62
      })
      this.setFooterPdf(doc, 259, 10, 14, 203, 244, 203)
      try {
        doc.save(`${this.$i18n.t('print_files.order_list_file_name')}.pdf`)
      } catch (err) {
        Sentry.captureException(err)
        this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
        this.loading = false
      }
      this.loading = false
    },
    async exportOrderListCsv () {
      await this.getOrderData()
      this.loading = true
      this.rows = []

      let csvContent = 'data:text/csv;charset=utf-8,'
      // this.rows.push([this.$i18n.t('print_files.order_ref'), this.$i18n.t('print_files.buyer_ref'), this.$i18n.t('print_files.company_name'), this.$i18n.t('print_files.address'), this.$i18n.t('print_files.status'), this.$i18n.t('print_files.weight') + ' [KG]', this.$i18n.t('print_files.volume') + ' [CBM]'])
      try {
        this.drops.forEach((drop) => {
          this.orderFile (drop)
        })
      } catch (err) {
        Sentry.captureException(err)
        this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
        this.loading = false
      }

      // sorts by order ref and then add the headers so they don't get sorted
      this.rows.sort((a, b) => (a[0] > b[0]) ? 1 : -1)
      this.rows.unshift([this.$i18n.t('print_files.order_ref'), this.$i18n.t('print_files.buyer_ref'), this.$i18n.t('print_files.company_name'), this.$i18n.t('print_files.address'), this.$i18n.t('print_files.status'), this.$i18n.t('print_files.weight') + ' [KG]', this.$i18n.t('print_files.volume') + ' [CBM]'])
      this.rows.forEach(function (rowArray) {
        let row = rowArray.join(';').replace(',', '-')
        csvContent += row + '\r\n'
      })
      try {
        this.generateCsv(csvContent, 'print_files.order_list_file_name')
      } catch (err) {
        Sentry.captureException(err)
        this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
        this.loading = false
      }
      this.loading = false
    },
    exportQuoteListPdf () {
      // console.log(this.getQuoteListExport)
      this.headOne = []
      this.headTwo = []
      this.body = []

      this.loading = true
      let Pdf = jsPDF
      let doc = new Pdf()
      this.addDocSettings(doc)

      doc.setFontSize(14)

      doc.setFontStyle('bold')
      doc.text(this.$i18n.t('print_files.quote_requests_list').toUpperCase(), 80, 10)
      doc.setFontStyle('normal')

      // header table
      this.setHeaderPdf()
      if (this.getQuoteListExport.length > 0) {
        this.headTwo.push(
          [
            { content: `${this.$i18n.t('print_files.price_request_date')}\n${this.$i18n.t('print_files.date_of_pricing')}` },
            { content: this.$i18n.t('print_files.company_name') },
            { content: this.$i18n.t('print_files.quote_status') },
            { content: this.$i18n.t('print_files.price') }
          ]
        )

        try {
          for (let i = 0; i < this.getQuoteListExport.length; i++) {
            this.quoteFile(i)
            this.body.push([this.quoteDate, this.quoteCompanyName, this.quoteStatus, this.quotePrice])
          }
        } catch (err) {
          console.log(err)
          Sentry.captureException(err)
          this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
          this.loading = false
        }

        doc.autoTable({
          head: this.headOne,
          styles: { fontSize: 10, textColor: [33, 33, 33], font: 'Roboto' },
          headStyles: { fillColor: [246, 246, 246] },
          startY: 20
        })

        doc.autoTable({
          head: this.headTwo,
          body: this.body,
          styles: { fontSize: 10, textColor: [33, 33, 33], font: 'Roboto' },
          theme: 'grid',
          rowPageBreak: 'avoid',
          headStyles: { fillColor: [255, 255, 255], lineWidth: 0.1 },
          columnStyles: { 2: { cellWidth: 40 } },
          startY: 60
        })

        this.setFooterPdf(doc, 175, 10, 10, 290, 160, 290)
        try {
          doc.save(`${this.$i18n.t('print_files.quote_list_file_name')}.pdf`)
        } catch (err) {
          console.log(err)
          Sentry.captureException(err)
          this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
          this.loading = false
        }
      } else {
        this.showSnackbar({ message: this.$t('snackbars.no_quotes'), color: 'error' })
      }
      this.loading = false
    },
    exportQuoteListCsv () {
      this.loading = true
      this.rows = []

      if (this.getQuoteListExport.length > 0) {
        let csvContent = 'data:text/csv;charset=utf-8,'
        this.rows.push([`${this.$i18n.t('print_files.price_request_date')}/${this.$i18n.t('print_files.date_of_pricing')}`, this.$i18n.t('print_files.company_name'), this.$i18n.t('print_files.quote_status'), this.$i18n.t('print_files.price')])
      
        try {
          for (let i = 0; i < this.getQuoteListExport.length; i++) {
            this.quoteFile(i)
            this.rows.push([this.quoteDate, this.quoteCompanyName, this.quoteStatus, this.quotePrice])
          }
        } catch (err) {
          console.log(err)
          Sentry.captureException(err)
          this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
          this.loading = false
        }
        this.rows.forEach(function (rowArray) {
          let row = rowArray.join(';').replace(',', '-')
          csvContent += row + '\r\n'
        })

        try {
          this.generateCsv(csvContent, 'print_files.quote_list_file_name')
        } catch (err) {
          console.log(err)
          Sentry.captureException(err)
          this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
          this.loading = false
        }
      } else {
        this.showSnackbar({ message: this.$t('snackbars.no_quotes'), color: 'error' })
      }
      this.loading = false
    }
  },
  created () {},
  watch: {
    // getShipmentResourceSchedule (value) {
    //   this.loading = false
    // }
  }
}
</script>

<style lang="scss" scoped>
  .btn-print:before {
    display: none;
  }
  .btn-text {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  span {
    font-size: 12px;
    // font-weight: 600;
    text-transform: capitalize;
    letter-spacing: 0;
    color: #202020;
  }
</style>
